var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import UserSvg from './user-01.icon.svg';
export const UserIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: UserSvg }));
_react_refresh_temp_1 = UserIcon;
$RefreshReg$(_react_refresh_temp_1, "UserIcon");
